import { ReactNode } from "react";
import { Button, Header, Segment, Grid, Popup } from "semantic-ui-react";

interface ICP4OnboardingWorkflowContainerProps {
  heading: string;
  subHeading: string;
  children: ReactNode | ReactNode[];
  backButtonProps?: ButtonBaseProps;
  nextButtonProps?: ButtonBaseProps;
}

interface ButtonBaseProps {
  disabled?: boolean;
  disabledText?: string;
  onClick: () => void;
}

export function ICP4OnboardingWorkflowContainer({ heading, subHeading, children, backButtonProps, nextButtonProps }: ICP4OnboardingWorkflowContainerProps) {
  return (
    <Segment style={{
      padding: "40px",
      background: '#FFFFFF',
      border: 'none',
      boxShadow: 'none'
    }}>
      <Grid>
        <Grid.Row>
          <Grid.Column>
            <div style={{
              marginBottom: '40px',
              borderBottom: '1px solid #E2E8F0',
              paddingBottom: '24px'
            }}>
              <Grid>
                <Grid.Row columns={2}>
                  <Grid.Column width={8}>
                    <Header as="h1" style={{
                      color: '#1A202C',
                      fontSize: '24px',
                      fontWeight: 600,
                      marginBottom: '8px'
                    }}>
                      {heading}
                    </Header>
                    <p style={{
                      color: '#718096',
                      fontSize: '16px',
                      margin: 0
                    }}>
                      {subHeading}
                    </p>
                  </Grid.Column>
                  <Grid.Column
                    style={{
                      display: 'flex',
                      justifyContent: 'flex-end',
                      alignItems: 'center'
                    }}

                  >
                    {backButtonProps && <Popup
                                    content={backButtonProps?.disabled && backButtonProps?.disabledText ? backButtonProps?.disabledText : undefined}
                                    disabled={!backButtonProps?.disabled}
                                    trigger={<div style={{ display: 'inline-block', float:"right", ...(backButtonProps?.disabled ? {cursor: 'not-allowed'}:{}) }}>
                                        <Button
                      onClick={backButtonProps?.onClick}
                      disabled={backButtonProps?.disabled}
                      style={{
                        background: '#FFFFFF',
                        color: '#6435C9',
                        border: '1px solid #6435C9',
                        borderRadius: '8px',
                        padding: '12px 24px',
                        height: '40px',
                        fontWeight: 500
                      }}
                    >
                      Back
                    </Button>
                                    </div>} />}
                    {nextButtonProps && <Popup
                                    content={nextButtonProps?.disabled && nextButtonProps?.disabledText ? nextButtonProps?.disabledText : undefined}
                                    disabled={!nextButtonProps?.disabled}
                                    trigger={<div style={{ display: 'inline-block', float:"right", ...(backButtonProps?.disabled ? {cursor: 'not-allowed'}:{}) }}><Button
                      primary
                      onClick={nextButtonProps?.onClick}
                      disabled={nextButtonProps?.disabled}
                      style={{
                        background: '#6435C9',
                        color: '#FFFFFF',
                        // @TODO: Evaluate...
                        opacity: true ? 1 : 0.6,
                        borderRadius: '8px',
                        padding: '12px 24px',
                        height: '40px',
                        fontWeight: 500
                      }}
                    >
                      Next
                    </Button></div>}/>}
                  </Grid.Column>
                </Grid.Row>
              </Grid>
            </div>
            <div style={{
              display: 'grid',
              gridTemplateColumns: '1fr',
              gap: '24px',
              width: '100%'
            }}>
              {children}
            </div>
          </Grid.Column>
        </Grid.Row>
      </Grid>
    </Segment>
  );
}